import React, { useState, useEffect } from "react";
import "../InvoiceModal.css";

// components imports
import CarrierTableLoader from "../../../Components/CarrierInnerTableLoader/CarrierInnerTableLoader";
// apis imports
// library imports
import { FaRegTimesCircle } from "react-icons/fa";
import { MdArrowCircleDown } from "react-icons/md";
import International from "./InvoiceSubComponents/International";
import ShipmentSummary from "./InvoiceSubComponents/ShipmentSummary";
import Tracking from "./InvoiceSubComponents/Tracking";
import Header from "./InvoiceSubComponents/Header";
import ShipmentDetails from "./InvoiceSubComponents/ShipmentDetails";
import Footer from "./InvoiceSubComponents/Footer";
import BillingUser from "./InvoiceSubComponents/BillingUser";
import Notes from "./InvoiceSubComponents/NotesUser";
import AdminActions from "./InvoiceSubComponents/AdminActions";
import OneTimeShipperImageStatus from "./OneTimeShipperImageStatus";
import Tooltip from "../../Tooltip/Tooltip";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import InvoiceActionsDropdown from "./InvoiceSubComponents/InvoiceActionsWithDocs";

const StaticInvoice = ({
  data,
  handleClose,
  downloadPdf,
  downloadDocs,
  setData,
  setShipments,
  getAllShipments,
  actions = true,
  loading,
  setSnack,
  refreshShipmentData,
}) => {
  const { t } = useTranslation("finances");
  const user = useSelector((state) => state.user);

  return (
    <>
      <div className="invoice__modal_wrap invoice__modal_style_optamize_wrap static__invoice_wrap">
        {loading === false ? (
          <>
            <div className="invoice__modal_box invoice__shipment_style_optamize_wrap">
              <div className="invoice__modal_downloadinvoicewrap">
                <div className="flex flex-wrap items-center gap-2 sm:gap-3">
                  {/* Download Invoice */}
                  <button
                    onClick={() => downloadPdf(data)}
                    className="flex items-center gap-1.5 rounded-md bg-brand px-2.5 py-1.5 text-xs font-medium text-white shadow hover:bg-brand-hover
                  sm:gap-2 sm:px-3 sm:py-2 sm:text-sm sm:leading-none"
                  >
                    <MdArrowCircleDown className="h-4 w-4 sm:h-5 sm:w-5" />
                    <span>{t("invoice.buttons.invoice")}</span>
                  </button>

                  {/* Download Label - disabled for oneTimeShipper users if shipment is not approved */}
                  {(() => {
                    const isOneTimeShipperNotApproved =
                      user?.role === "oneTimeShipper" &&
                      data?.shipment_type === "oneTimeShipper";

                    const hasImages =
                      data?.one_time_package_images &&
                      Array.isArray(data.one_time_package_images) &&
                      data.one_time_package_images.length > 0;

                    const isDisabled = isOneTimeShipperNotApproved;

                    let tooltipText = "";
                    if (isOneTimeShipperNotApproved) {
                      if (!hasImages) {
                        tooltipText = t("invoice.labelNeedsImages");
                      } else {
                        tooltipText = t("invoice.labelNeedsApproval");
                      }
                    }

                    const button = (
                      <button
                        onClick={() => {
                          if (!isDisabled) {
                            downloadDocs(data, "label");
                          }
                        }}
                        disabled={isDisabled}
                        className="flex items-center gap-1.5 rounded-md border border-ui-border bg-ui-surface px-2.5 py-1.5 text-xs font-medium text-ui-text hover:bg-ui-surface-sunken sm:gap-2 sm:px-3 sm:py-2 sm:text-sm sm:leading-none"
                        style={{
                          opacity: isDisabled ? 0.5 : 1,
                          cursor: isDisabled ? "not-allowed" : "pointer",
                        }}
                      >
                        <MdArrowCircleDown className="h-4 w-4 sm:h-5 sm:w-5" />
                        <span>{t("invoice.buttons.label")}</span>
                      </button>
                    );

                    return tooltipText ? (
                      <Tooltip title={tooltipText}>{button}</Tooltip>
                    ) : (
                      button
                    );
                  })()}

                  {/* Manage Declaration */}
                  {data?.single_shipping_invoice && (
                    <>
                      <InvoiceActionsDropdown
                        documents={data?.shipping_document || []}
                        shipmentId={data?.id}
                        onDownloadDeclaration={() =>
                          downloadDocs(data, "declaration")
                        }
                        onDownloadAllZip={() => {}}
                        onDocumentsUpdate={(documents) => {
                          setData((prev) => ({
                            ...prev,
                            shipping_document: documents,
                          }));
                        }}
                        onDocumentDelete={(deleteId) => {
                          setData((prev) => ({
                            ...prev,
                            shipping_document: prev.shipping_document.filter(
                              (d) => d.id !== deleteId,
                            ),
                          }));
                        }}
                      />
                    </>
                  )}

                  {/* Close */}
                  <button
                    onClick={handleClose}
                    className="flex items-center gap-1.5 rounded-md bg-state-danger px-2.5 py-1.5 text-xs font-medium text-white shadow
                  hover:bg-state-danger sm:gap-2 sm:px-3 sm:py-2 sm:text-sm sm:leading-none"
                  >
                    <FaRegTimesCircle className="h-4 w-4 sm:h-5 sm:w-5" />
                    <span className="hidden sm:inline">
                      {t("common:actions.close")}
                    </span>
                  </button>
                </div>
              </div>
              <Header data={data} />

              {user?.role === "oneTimeShipper" && (
                <OneTimeShipperImageStatus
                  shipmentData={data}
                  refreshShipmentData={refreshShipmentData}
                  onImageUploadSuccess={() => {
                    if (getAllShipments) {
                      getAllShipments(1, 20, "");
                    }
                    if (setSnack) {
                      setSnack((snack) => ({
                        ...snack,
                        open: true,
                        text: t("invoice.imagesUploaded"),
                        severity: "success",
                      }));
                    }
                  }}
                />
              )}
              <ShipmentSummary data={data} />
              <International data={data} />
              <ShipmentDetails data={data} />
              {user?.role !== "warehouseUser" &&
                user?.role !== "Carrier" &&
                actions != false && (
                  <AdminActions
                    type="user"
                    data={data}
                    setShipments={setShipments}
                    setData={setData}
                    getAllShipments={getAllShipments}
                  />
                )}
              <BillingUser data={data} />
              <Notes data={data} />
              <Tracking data={data} />
              <Footer data={data} />
            </div>
          </>
        ) : (
          <div className="fulfilment_tier_loader">
            <CarrierTableLoader />
          </div>
        )}
      </div>
    </>
  );
};

export default StaticInvoice;
